import Spotify from '../../images/spotify.png';
import Amazon from '../../images/amazon.png';
import Chat from '../../images/chat-box.png';

const arr = [
  {
    img: `${Spotify}`,
    name: 'MySpotify',
    desc: 'Revisit your Spotify favorites, find new artists similar to the ones you love, explore top tracks by your favorite artists, find the latest songs you have listened to filtered by mood, all with MySpotify. This is a client side application, and requires the user to have a Spotify account(Free or Premium). It is a progressive web app(PWA).',
    link: 'http://myspotify-aa2ed.web.app/',
    github: 'https://github.com/Swapnil-2001/MySpotify'
  },
  {
    img: `${Amazon}`,
    name: 'Amazon-clone',
    desc: 'A clone of the Amazon website, built using React. The application is client side, and includes features such as searching for available items, adding to cart/removing from cart, signup/login functionality, and individual pages for products with zoom-in capabilities. The design is fully responsive.',
    link: 'http://clone-cafe3.web.app/',
    github: 'https://github.com/Swapnil-2001/Amazon-clone'
  },
  {
    img: `${Chat}`,
    name: 'Chat App',
    desc: 'A full-stack chat application, it has React as the frontend framework and uses Apollo to interact with a GraphQL backend. Users can sign up and add posts, like other people\'s posts, comment on posts, and delete their own posts.',
    link: 'https://lucid-archimedes-eeb6ef.netlify.app/',
    github: 'https://github.com/Swapnil-2001/merng-client'
  }
]

export default arr;